import {
    FETCH_RECENT_MONITOR,
    LIST_RECENT_MONITOR
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    list: [],
    page: 1,
    size: 10,
    totals: 0
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_RECENT_MONITOR:
            return {
                ...state,
                ...init,
                isLoading: true,
                filter: payload
            };
        case LIST_RECENT_MONITOR:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        default:
            return state;
    }
}